/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hof_CtaInputs */

const en_hof_cta = /** @type {(inputs: Hof_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Become the next person in Mark's Hall of Fame`)
};

const es_hof_cta = /** @type {(inputs: Hof_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sé la próxima persona en el Salón de la fama de Mark`)
};

const de_hof_cta = /** @type {(inputs: Hof_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Werden Sie die nächste Person in Marks Hall of Fame`)
};

const zh_hof_cta = /** @type {(inputs: Hof_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`成为 Mark 名人堂的下一个人`)
};

const ar_hof_cta = /** @type {(inputs: Hof_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`كن الشخص التالي في قاعة مشاهير Mark`)
};

const fr_hof_cta = /** @type {(inputs: Hof_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Devenez la prochaine personne au Temple de la renommée de Mark`)
};

const vi_hof_cta = /** @type {(inputs: Hof_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trở thành người tiếp theo trong Đại sảnh danh vọng của Mark`)
};

const sw_hof_cta = /** @type {(inputs: Hof_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kuwa mtu anayefuata katika Ukumbi wa Umaarufu wa Mark`)
};

const th_hof_cta = /** @type {(inputs: Hof_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`มาเป็นบุคคลต่อไปในหอเกียรติยศของ Mark`)
};

const bs_hof_cta = /** @type {(inputs: Hof_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Postanite sljedeća osoba u Markovoj Kući slavnih`)
};

const ja_hof_cta = /** @type {(inputs: Hof_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Markの殿堂入りを目指そう`)
};

const ko_hof_cta = /** @type {(inputs: Hof_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark의 명예의 전당에 이름을 올릴 다음 주인공이 되세요`)
};

const pt_hof_cta = /** @type {(inputs: Hof_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seja a próxima pessoa no Hall da Fama do Mark`)
};

const it_hof_cta = /** @type {(inputs: Hof_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diventa la prossima persona nella Hall of Fame di Mark`)
};

const sv_hof_cta = /** @type {(inputs: Hof_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bli nästa person i Marks Hall of Fame`)
};

const nl_hof_cta = /** @type {(inputs: Hof_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Word de volgende in Marks Hall of Fame`)
};

const da_hof_cta = /** @type {(inputs: Hof_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bliv den næste person i Marks Hall of Fame`)
};

const nb_hof_cta = /** @type {(inputs: Hof_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bli neste person i Marks Hall of Fame`)
};

const fi_hof_cta = /** @type {(inputs: Hof_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ole seuraava Markin Hall of Famessa`)
};

const pl_hof_cta = /** @type {(inputs: Hof_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zostań kolejną osobą w Galerii sław Marka`)
};

const ru_hof_cta = /** @type {(inputs: Hof_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Станьте следующим в Зале славы тренера Mark`)
};

const tr_hof_cta = /** @type {(inputs: Hof_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark'ın Şöhretler Müzesindeki bir sonraki isim siz olun`)
};

const hi_hof_cta = /** @type {(inputs: Hof_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark के हॉल ऑफ फेम में अगला नाम आपका हो`)
};

const id_hof_cta = /** @type {(inputs: Hof_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jadilah orang berikutnya di Balai Kehormatan Mark`)
};

const ms_hof_cta = /** @type {(inputs: Hof_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jadilah insan seterusnya dalam Dewan Kemasyhuran Mark`)
};

const cs_hof_cta = /** @type {(inputs: Hof_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stát se další osobou v Markově síni slávy`)
};

const el_hof_cta = /** @type {(inputs: Hof_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Γίνετε το επόμενο όνομα στο Πάνθεον Διασήμων του Mark`)
};

const he_hof_cta = /** @type {(inputs: Hof_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`להיות האדם הבא באולם התהילה של Mark`)
};

const af_hof_cta = /** @type {(inputs: Hof_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Word die volgende persoon in Mark se Eregalery`)
};

const hu_hof_cta = /** @type {(inputs: Hof_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legyen a következő ember Mark Hírességek Csarnokában`)
};

/**
* | output |
* | --- |
* | "Become the next person in Mark's Hall of Fame" |
*
* @param {Hof_CtaInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const hof_cta = /** @type {((inputs?: Hof_CtaInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hof_CtaInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_hof_cta(inputs)
	if (locale === "de") return de_hof_cta(inputs)
	if (locale === "zh") return zh_hof_cta(inputs)
	if (locale === "ar") return ar_hof_cta(inputs)
	if (locale === "fr") return fr_hof_cta(inputs)
	if (locale === "vi") return vi_hof_cta(inputs)
	if (locale === "sw") return sw_hof_cta(inputs)
	if (locale === "th") return th_hof_cta(inputs)
	if (locale === "bs") return bs_hof_cta(inputs)
	if (locale === "ja") return ja_hof_cta(inputs)
	if (locale === "ko") return ko_hof_cta(inputs)
	if (locale === "pt") return pt_hof_cta(inputs)
	if (locale === "it") return it_hof_cta(inputs)
	if (locale === "sv") return sv_hof_cta(inputs)
	if (locale === "nl") return nl_hof_cta(inputs)
	if (locale === "da") return da_hof_cta(inputs)
	if (locale === "nb") return nb_hof_cta(inputs)
	if (locale === "fi") return fi_hof_cta(inputs)
	if (locale === "pl") return pl_hof_cta(inputs)
	if (locale === "ru") return ru_hof_cta(inputs)
	if (locale === "tr") return tr_hof_cta(inputs)
	if (locale === "hi") return hi_hof_cta(inputs)
	if (locale === "id") return id_hof_cta(inputs)
	if (locale === "ms") return ms_hof_cta(inputs)
	if (locale === "cs") return cs_hof_cta(inputs)
	if (locale === "el") return el_hof_cta(inputs)
	if (locale === "he") return he_hof_cta(inputs)
	if (locale === "af") return af_hof_cta(inputs)
	if (locale === "hu") return hu_hof_cta(inputs)
	return en_hof_cta(inputs)
});